import { render, staticRenderFns } from "./DocumentAdd.vue?vue&type=template&id=4deb596e&scoped=true"
import script from "./DocumentAdd.vue?vue&type=script&lang=js"
export * from "./DocumentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deb596e",
  null
  
)

export default component.exports